// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import { TabbedViews, Form } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const MappingIDPage = (props) => {
  useRetractSidebar()

  return (
    <div id="mapping-id-page">
      <EntityEditForm entities="mapping-ids" id={props.match.params.id} resource="Mapping IDs">
        {({ disabled, item, onChange, schema }) => (
          <TabbedViews key={item._id}>
            <Form
              title="Metadata"
              item={item}
              onChange={onChange}
              schema={schema}
              fields={[{ name: 'name' }, { name: 'description' }, { name: 'products' }]}
              disabled={disabled}
            />

            <ListView
              title="Destinations"
              columns={[
                {
                  key: 'name',
                  link: '/destinations/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  key: 'company.name',
                  link: '/companies/:company._id',
                  name: 'Company',
                },
                {
                  key: 'mapping_id.name',
                  link: '/mapping-ids/:mapping_id._id',
                  name: 'Mapping ID',
                },
                {
                  key: 'event_sources',
                  name: 'Event Sources',
                },
              ]}
              queryString={{ 'mapping_id._id': item._id }}
              entities="destinations"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />
          </TabbedViews>
        )}
      </EntityEditForm>
    </div>
  )
}

export default MappingIDPage
